/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const InfoBubbleIcon = ({ className }) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g
      id="→-Jobsuche"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="FR_Jobdetail_language-2"
        transform="translate(-257.000000, -185.000000)"
        fill="#505058"
      >
        <g id="Group-7" transform="translate(257.000000, 185.000000)">
          <path
            d="M14,27 C11.7792533,27 9.58888333,26.4306 7.66570667,25.3533767 L7.35604667,25.1799133 L7.01367,25.2735133 L1.25969667,26.84608 C1.25233,26.84556 1.24240667,26.8421367 1.24032667,26.8421367 C1.24032667,26.8421367 1.24011,26.8421367 1.24006667,26.84218 C1.23989333,26.8412267 1.23993667,26.8372833 1.24015333,26.83633 L2.80232,21.1206633 L2.89743667,20.77274 L2.71760333,20.4600467 C2.18373667,19.5318467 1.76635,18.53661 1.47727333,17.5023733 C1.16055,16.36756 1,15.1891967 1,14 C1,6.83175667 6.83175667,1 14,1 C21.1682,1 27,6.83175667 27,14 C27,21.1682433 21.1682,27 14,27 M14,0 C6.2803125,0 0,6.2803125 0,14 C0,15.2796875 0.1728125,16.5484375 0.5140625,17.77125 C0.8246875,18.8825 1.273125,19.954375 1.850625,20.9584375 L0.2734375,26.7290625 C0.20125,27.0003125 0.2559375,27.2803125 0.424375,27.4990625 C0.59294375,27.7192125 0.86695,27.8446875 1.139075,27.8446875 C1.21305625,27.8446875 1.28690625,27.8354125 1.3584375,27.81625 L7.1771875,26.2259375 C9.2509375,27.3875 11.6046875,28 14,28 C21.7196875,28 28,21.7196875 28,14 C28,6.2803125 21.7196875,0 14,0"
            id="Fill-1"
            transform="translate(14.000000, 14.000000) scale(-1, 1) translate(-14.000000, -14.000000) "
          ></path>
          <polygon
            id="Fill-3"
            points="16.5 19.5 16.5 21 11.5 21 11.5 19.5 13 19.5 13 13 11.5 13 11.5 11.5 15 11.5 15 19.5"
          ></polygon>
          <path
            d="M15,8.5 C15,9.3281 14.3281,10 13.5,10 C12.67185,10 12,9.3281 12,8.5 C12,7.6719 12.67185,7 13.5,7 C14.3281,7 15,7.6719 15,8.5"
            id="Fill-5"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default InfoBubbleIcon;
